<template>
	<div class="counselorBack">
		<!-- --- header -->
		<v-app-bar app class="couselorHead">
			<div style="width:100%">
				<v-layout class="bigHeader" align-center>
					{{ reservedaysData.title }}
					<v-spacer />
					<!-- 상담사명, 로그아웃  -->
					<span class="counselorid">{{ $store.state.counserlorLoginData.name }} </span>
					<span class="counselorid ml-5"> {{ $store.state.counserlorLoginData.counselorid }}</span>

					<v-divider vertical class="mx-4 my-2 vertical_divider" />

					<v-btn icon depressed small @click="logout" class="mr-4">
						<v-icon medium>
							mdi-logout
						</v-icon></v-btn
					>
					<!-- <btn :btn="logoutbtn" btn_txt="Logout" @click="logout"></btn> -->
				</v-layout>
			</div>
		</v-app-bar>
		<v-layout class="counselorContents" wrap>
			<v-flex xs12>
				<!-- --- 왼쪽 content  -->
				<div class="counselor_content_wrap">
					<!-- viewport  -->
					<v-layout column :class="$vuetify.breakpoint.xs ? 'pre-viewport_counselor rounded' : 'pre-viewport_counselor ml-5 rounded'">
						<v-layout wrap class="mb-2">
							<v-flex xs12>
								<!-- --- 고객 이름, 휴대전화번호 -->
								<p class="mb-1 rightSort"><v-icon small color="black">mdi-square</v-icon> 이름, 휴대전화번호, 대기번호를 확인해 주세요</p>
								<v-layout align-center>
									<txtField :txtField="nameTxtfield" v-model="nameTxtfield.value" class="customerInfo mr-2"></txtField>
									<txtField :txtField="phoneTxtfield" v-model="phoneTxtfield.value" class="customerInfo mr-2"></txtField>
									<txtField :txtField="waitingNumTxtfield" v-model="waitingNumTxtfield.value" class="customerInfo"></txtField>
								</v-layout>
							</v-flex>
							<!--  개인정보 수집 및 마케팅활용 여부  -->
							<!-- <v-flex lg6 xs12 :class="$vuetify.breakpoint.xs ? 'mt-4' : 'pl-12'">
								<p class="mb-1 rightSort"><v-icon small color="black">mdi-square</v-icon> 개인정보 수집 및 마케팅활용 여부</p>
								<check-box :check="check1" @click="checkAgree"></check-box>
								<check-box :check="check2" @click="checkAgree"></check-box>
							</v-flex> -->
						</v-layout>
						<view-port class="view-port_counselor" />
					</v-layout>
				</div>
			</v-flex>
			<v-navigation-drawer
				v-model="counselorInput"
				absolute
				temporary
				right
				:width="counselorInput ? '50%' : '0%'"
				:permanent="counselorInput"
			>
				<!-- --- 오른쪽 content -->
				<v-layout justify-end>
					<v-btn icon @click="counselorInput = !counselorInput">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-layout>
				<div :class="$vuetify.breakpoint.xs ? 'px-4' : 'px-6'" style="width:100%">
					<!-- 고객 추적 데이터 -->
					<div>
						<div class="rightSort mt-2">
							<span class="mr-2"><v-icon small color="black">mdi-square</v-icon> 현재 고객 추적 데이터</span>
							<!-- 추적 데이터 히스토리 모달 버튼 -->
							<btn :btn="historyBtn" btn_txt="History" @click="userHistory"></btn>
						</div>
						<div>
							<datatable :datatable="datatable" class="tbl-type01" />
							<v-pagination :color="$store.state.PointColor1" v-model="datatable.page" :length="datatable.pageCount"></v-pagination>
						</div>
					</div>
					<!-- 고객 성향 -->
					<p class="rightSort mt-4"><v-icon small color="black">mdi-square</v-icon> 고객 성향을 선택하세요</p>
					<radio-button :radios="radios"></radio-button>
					<!-- 고객 코멘트 -->
					<p class="rightSort mb-0"><v-icon small color="black">mdi-square</v-icon> 고객 코멘트</p>
					<v-chip-group multiple column active-class="PointColor1--text" v-model="selectedTag" v-if="reservedaysData.commentTag">
						<v-chip v-for="(tag, i) in reservedaysData.commentTag" :key="i" filter>
							{{ tag }}
						</v-chip>
					</v-chip-group>
					<textArea :area="commentTxtfield" v-model="custComment" />
					<v-divider class="my-4" />
					<!-- 상담 고객 리스트  -->
					<p class="waitNum">
						| 상담고객 총: <span>{{ waitNum }}</span
						>명 대기중
					</p>
					<v-divider class="my-2" />
					<btn v-if="!counseringData.name" :btn="sendBtn" :disabled="waitNum === 0" btn_txt="상담알림 보내기" @click="send"></btn>
					<btn v-else :btn="sendBtn" btn_txt="상담 완료" @click="complete"></btn>
					<btn v-if="counseringData.name" :btn="sendBtn" btn_txt="미처리" class="ml-2" @click="setStat2"></btn>
					<btn
						v-if="counseringData.name && $route.params.code !== 'gvq0m2bdi2a'"
						:btn="sendBtn"
						btn_txt="재호출 보내기"
						class="ml-2"
						@click="sendAlertTalk()"
					></btn>
					<btn class="ml-2" :btn="sendBtn" btn_txt="상담수기 등록" @click="directwaitingDailog"></btn>
					<v-divider class="mt-2" />
				</div>
			</v-navigation-drawer>
		</v-layout>
		<v-btn class="fab-counselor-icon" color="primary" dark absolute bottom right fab @click="counselorInput = !counselorInput">
			<v-icon>mdi-pencil</v-icon>
		</v-btn>
		<!-- <v-footer color="white" class="tracking-table">
			<p class="rightSort mt-7"><v-icon small color="black">mdi-square</v-icon> 현재 고객 추적 데이터</p>
			<div>
				<datatable :datatable="datatable" class="tbl-type01" />
			</div>
		</v-footer> -->
		<v-dialog v-model="infoDialog.dialog" width="30vh" persistent>
			<v-card>
				<v-card-title>
					상담원 정보 확인
				</v-card-title>
				<v-card-text class="pb-3">
					<v-layout> 상담원 이름: {{ infoDialog.name }} <br />상담석 번호: {{ infoDialog.seat }} </v-layout>
				</v-card-text>
				<h2 class="ml-6">위의 정보가 맞으십니까?</h2>
				<v-card-actions>
					<v-spacer></v-spacer>
					<btn :btn="infoDialog.btn" :btn_txt="infoDialog.btn.submit" @click="infoDialog.dialog = false"></btn>
					<btn :btn="infoDialog.btn" :btn_txt="infoDialog.btn.logout" @click="selfAuthentication()"></btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<alertModal :setdialog="alertModal" :clickDeleteBtnModal="deleteAccount" />
		<alertModal :setdialog="sendAlertModal" :clickDeleteBtnModal="createSendMessage" />
		<alertModal2 :setdialog="alertModal2" />
		<alertModal3 :setdialog="alertModal3" :userExport="userExport" :type="'co'" />
		<download-excel
			class="btn btn-default"
			:id="alertModal3.phone"
			:data="alertModal3.datatable.items"
			style="display:none"
			:fields="alertModal3.json_fields"
			type="text/csv;charset=utf8"
			worksheet="My Worksheet"
			:name="alertModal3.name + '_' + alertModal3.phone"
		/>
		<v-dialog v-model="direct_dialog" persistent min-width="800px" content-class="waitingDialog">
			<v-layout class="counselorContents mt-0" wrap>
				<v-flex xs12>
					<!-- --- 왼쪽 content  -->
					<div>
						<!-- viewport  -->
						<v-layout column :class="$vuetify.breakpoint.xs ? 'pre-viewport_counselor rounded' : 'pre-viewport_counselor ml-5 rounded'">
							<v-layout wrap class="mb-2">
								<v-flex xs12>
									<!-- --- 고객 이름, 휴대전화번호 -->
									<v-layout align-center>
										<p class="mb-1 rightSort">
											<v-icon small color="black">mdi-square</v-icon> 이름, 휴대전화번호, 대기번호를 입력해 주세요
										</p>
										<v-spacer></v-spacer>
										<v-btn icon @click="direct_dialog = !direct_dialog">
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-layout>

									<v-layout align-center>
										<txtField :txtField="direct.nameTxtfield" v-model="direct.nameTxtfield.value" class="customerInfo"></txtField>
										<v-text-field
											outlined
											label="고객 휴대전화번호"
											placeholder="고객 휴대전화번호"
											class="customerInfo-phone ml-4 mt-2"
											color="primary"
											v-mask="'###-####-####'"
											v-model="direct.phoneTxtfield.value"
											hide-details
										></v-text-field>
									</v-layout>
								</v-flex>
							</v-layout>
							<viewPortDirectWaiting class="view-port_counselor" :key="componentKey" />
						</v-layout>
					</div>
				</v-flex>
				<v-btn
					class="fab-counselor-icon-2"
					color="primary"
					dark
					absolute
					bottom
					right
					fab
					@click="counselorInputDirect = !counselorInputDirect"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
				<v-navigation-drawer
					v-model="counselorInputDirect"
					absolute
					temporary
					right
					:width="counselorInputDirect ? '50%' : '0%'"
					:permanent="counselorInputDirect"
				>
					<p class="rightSort mt-2 mx-6 mb-0"><v-icon small color="black">mdi-square</v-icon> 개인정보 수집동의를 진행해주세요</p>
					<termsAgreeTemp :urlInfo="$route.path" :changeBtn="changeBtn" class="mx-6 my-4" />
					<!-- --- 오른쪽 content -->
					<div :class="$vuetify.breakpoint.xs ? 'px-4' : 'px-6'" style="width:100%">
						<!-- 고객 성향 -->
						<p class="rightSort mt-4"><v-icon small color="black">mdi-square</v-icon> 고객 성향을 선택하세요</p>
						<radio-button :radios="direct.radios"></radio-button>
						<!-- 고객 코멘트 -->
						<p class="rightSort mb-0"><v-icon small color="black">mdi-square</v-icon> 고객 코멘트</p>
						<!-- <v-chip-group multiple column active-class="PointColor1--text" v-model="selectedTag" v-if="reservedaysData.commentTag">
							<v-chip v-for="(tag, i) in reservedaysData.commentTag" :key="i" filter>
								{{ tag }}
							</v-chip>
						</v-chip-group> -->
						<textArea :area="commentTxtfield" v-model="direct.custComment" />
						<v-divider class="my-2" />
						<btn :btn="sendBtn" btn_txt="취소" @click="counselorInputDirect = false"></btn>
						<btn class="ml-2" :btn="sendBtn" btn_txt="등록하기" @click="createDirectwaitingDailog"></btn>
					</div>
				</v-navigation-drawer>
			</v-layout>
		</v-dialog>
		<agree-dialog :setdialog="agreeDialog" />
	</div>
</template>

<script>
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'

import {
	agreeDialog,
	alertModal,
	alertModal2,
	alertModal3,
	btn,
	datatable,
	radioButton,
	termsAgreeTemp,
	textArea,
	txtField,
	viewPort,
	viewPortDirectWaiting,
} from '@/components/index'
import downloadExcel from 'vue-json-excel'
export default {
	components: {
		termsAgreeTemp,
		textArea,
		downloadExcel,
		txtField,
		alertModal,
		radioButton,
		btn,
		viewPort,
		viewPortDirectWaiting,
		alertModal2,
		alertModal3,
		datatable,
		agreeDialog,
	},
	data() {
		return {
			counselorInputDirect: false,
			counselorInput: false,
			check2: {
				color: 'primary',
				class: 'smallLabel',
				value: false,
				label: '개인정보 수집동의',
				onicon: 'mdi-check-circle',
				officon: 'mdi-check-circle-outline',
			},
			agreeDialog: {
				dialog: false,
				title: '',
				content: '',
			},
			componentKey: 0,
			direct: {
				custComment: '',
				radios: {
					radioSelected: '',
					items: [
						{ label: 'S', value: 'S' },
						{ label: 'A', value: 'A' },
						{ label: 'B', value: 'B' },
						{ label: 'C', value: 'C' },
						{ label: 'D', value: 'D' },
					],
					color: '#202840',
				},
				nameTxtfield: {
					value: '',
					color: 'primary',
					outlined: true,
					label: '고객성명',
					placeholder: '고객성명',
				},
				phoneTxtfield: {
					value: '',
					outlined: true,
					label: '고객 휴대전화번호',
					placeholder: '고객 휴대전화번호',
					type: 'Number',
					onlyNumber: true,
					max: 99999999999999999999999,
				},
			},
			direct_dialog: false,
			realTimeWatingList: [],
			infoDialog: {
				dialog: true,
				btn: {
					submit: '예',
					logout: '아니오',
					outlined: true,
				},
			},
			selectedTag: [],
			datatable: {
				headers: [
					{ text: '상담 날짜', value: 'cdate' },
					{ text: '사업지 명', value: 'title' },
					{ text: '상담사 아이디', value: 'counselorid' },
					{ text: '고객 등급', value: 'custlike' },
					{ text: '코멘트 태그', value: 'commentTag' },
					{ text: '코멘트', value: 'recomand' },
					{ text: '방문 예약 날짜', value: 'rdate' },
				],
				items: [],
				hidedefaultfooter: true,
				noweditting: '',
				itemPerPage: 5,
				page: 1,
				pageCount: 3,
			},
			// --- header 텍스트 data---
			header: { headerTitle: 'test : 더샵과 함께 아산의 내일이 빛난다!', bigHeader: '테스트 캠페인 타이틀' },
			// -- 체크박스 data
			check1: {
				color: 'primary',
				class: 'smallLabel',
				value: false,
				label: '개인정보 수집동의',
				readonly: true,
			},
			check3: {
				color: 'primary',
				class: 'smallLabel',
				value: false,
				label: '동의 없이 상담 진행',
			},
			// --- 고객 성명, 전화번호 텍스트 박스 ---
			nameTxtfield: {
				value: '',
				outlined: true,
				label: '고객성명',
				placeholder: '고객성명',
				readonly: true,
			},
			phoneTxtfield: {
				value: '',
				outlined: true,
				label: '고객 휴대전화번호',
				placeholder: '고객 휴대전화번호',
				readonly: true,
			},
			waitingNumTxtfield: {
				value: '',
				outlined: true,
				label: '고객 대기번호',
				placeholder: '고객 대기번호',
				readonly: true,
			},
			// --- 고객성향 radio button
			radios: {
				radioSelected: '',
				items: [
					{ label: 'S', value: 'S' },
					{ label: 'A', value: 'A' },
					{ label: 'B', value: 'B' },
					{ label: 'C', value: 'C' },
					{ label: 'D', value: 'D' },
				],
				color: '#202840',
			},
			// --- 로그아웃 모달 ---
			alertModal2: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
			},
			alertModal: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
			},
			sendAlertModal: {
				dialog: false,
				text: '고객을 호출하기 위해 알림톡을 전송 하시겠습니까?',
				btnText: '보내기',
			},
			logoutbtn: {
				class: '',
				color: 'primary',
				dark: true,
			},
			sendBtn: {
				color: '#202840',
				dark: false,
				class: 'white--text',
			},
			historyBtn: {
				dark: true,
				color: '#202840',
			},
			waitNum: 0,

			draggableDisable: false,
			viewportList: [],
			inputBoxesData: [],
			groups: [],
			locationSelected: '',
			picker: {
				date: '',
				errorMessage: '',
				allowedDates: '2021-5-30',
			},
			timeData: [],
			selectedTime: '',
			sel1: { label: '설문', value: '', errorMessage: '', hideDetail: true, items: [], outlined: true }, // 인풋박스 셀렉트 박스 옵션
			sel2: { label: '사업지', value: '', errorMessage: '', hideDetail: true, items: [], outlined: true }, // 사업지 셀렉트 박스 옵션
			sel3: { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }, // viewport 셀렉트 박스 옵션
			txt: {
				value: '',
				maxlength: '255',
				outlined: true,
				autofocus: false,
				hideDetail: false,
				errorMessage: '',
			},
			reservedaysData: {
				business: { color: 'black' },
			},
			counseringData: {},
			waitingId: '',
			custComment: '', // 고객 코멘트 v-model
			commentTxtfield: {
				height: 70,
				noresize: '',
				value: '',
				outlined: true,
				placeholder: '',
				readonly: false,
			}, // 고객 코멘트 텍스트 필드 옵션
			//히스토리 모달
			alertModal3: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
				datatable: { headers: [], items: [] },
				json_fields: {},
			},
			socket: '',
		}
	},
	created() {
		if (localStorage.getItem('counserlor') === null) {
			alert('권한이 없는 사용자 입니다. 다시 로그인해 주세요.')
			this.$router.push({ name: 'counselorlogin' })
		}
		this.counselors(localStorage.getItem('counserlor').split(',')[0], localStorage.getItem('counserlor').split(',')[1])
		this.reservedays()
		this.waitings()
	},
	mounted() {
		this.waitingsSocket() // socket method
	},
	methods: {
		changeBtn() {
			if (this.$store.state.check2.value && this.setdialog.numtxtField.value.length > 6 && this.setdialog.nametxtField.value !== '') {
				this.nextBtn.class = 'customBtn'
			} else {
				this.nextBtn.class = 'disabledBtn'
				// this.nextBtn1.color = this.$store.state.PointColor7
			}
		},
		detail(num) {
			this.terms(num)
		},
		terms(num) {
			const data = {
				stat: 1,
				type: num,
			}
			this.$store.dispatch('terms', data).then(res => {
				this.agreeDialog.dialog = true
				if (res.data.terms.length > 0) {
					this.agreeDialog.title = res.data.terms[0].title
					this.agreeDialog.content = res.data.terms[0].content
				}
			})
		},
		createDirectwaitingDailog() {
			let ok = 0

			// if (!this.$store.state.check2.value) {
			// 	this.alertModal2.dialog = true
			// 	this.alertModal2.text = '이용 약관 동의 (필수)을 동의해주세요.'
			// 	ok += 1
			// 	return
			// }
			if (!this.$store.state.check3.value) {
				this.alertModal2.dialog = true
				this.alertModal2.text = '개인정보수집•이용동의 (필수)을 동의해주세요.'
				ok += 1
				return
			}
			// if (!this.$store.state.check4.value) {
			// 	this.alertModal2.dialog = true
			// 	this.alertModal2.text = '고유식별 수집동의 (필수)을 동의해주세요.'
			// 	ok += 1
			// 	return
			// }
			if (this.direct.radios.radioSelected === '') {
				this.alertModal2.dialog = true
				this.alertModal2.text = '고객 성향을 선택해 주세요.'
				ok += 1
				return
			}

			if (this.direct.phoneTxtfield.value === '') {
				this.alertModal2.dialog = true
				this.alertModal2.text = '고객 휴대전화번호를 입력해 주세요.'
				ok += 1
				return
			}
			if (this.direct.nameTxtfield.value === '') {
				this.alertModal2.dialog = true
				this.alertModal2.text = '고객 이름을 입력해 주세요.'
				ok += 1
				return
			}
			let result = this.$store.state.reservedayInputBoxDirect.categories
			// 거주지(거주지역) 항목은 선택값이 obj.value가 아닌 searchsel_city에 저장되므로 필수값 검증에서 제외
			const isLocationItem = obj => {
				if (!obj) return false
				if (typeof obj.tag === 'string' && obj.tag.toLowerCase().indexOf('location') !== -1) return true
				if (typeof obj.contents === 'string' && obj.contents.indexOf('거주지역') !== -1) return true
				return false
			}
			for (let i = 0; i < result.length; i++) {
				if (result[i].musthave && !isLocationItem(result[i])) {
					if (result[i].value === '') {
						this.alertModal2.dialog = true
						this.alertModal2.text = result[i].contents
						ok += 1
						return
					}
				}
			}
			const checkBox = []
			const checkone = []
			const textfiled = []
			let userDataInput = []
			let sex = null
			let realname = null
			let age = null
			let qualification = null
			let homeOwnership = null
			let bankBook = null
			let purpose = null
			let subscribe = null
			let floor = null
			let houseAcreage = null
			let acreageUnit = null
			let location = null
			let locationType = null
			this.$store.state.reservedayInputBoxDirect.categories.forEach(obj => {
				if (obj.tag === 'name') {
					realname = obj.items.value
				} else if (obj.tag === 'age') {
					if (obj.category_details.length > 0 && obj.value)
						age = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'sex') {
					if (obj.category_details.length > 0 && obj.value)
						sex = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'qualification') {
					if (obj.category_details.length > 0 && obj.value)
						qualification = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'homeOwnership') {
					if (obj.category_details.length > 0 && obj.value)
						homeOwnership = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'bankBook') {
					if (obj.category_details.length > 0 && obj.value)
						bankBook = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'purpose') {
					if (obj.category_details.length > 0 && obj.value)
						purpose = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'subscribe') {
					if (obj.category_details.length > 0 && obj.value)
						subscribe = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'floor') {
					if (obj.category_details.length > 0 && obj.value)
						floor = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'houseAcreage') {
					if (obj.category_details.length > 0 && obj.value) {
						houseAcreage = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						acreageUnit = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				} else if (obj.tag === 'locationType') {
					if (obj.category_details.length > 0 && obj.value) {
						location = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						locationType = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				}
				if (obj.type === 10) {
					checkone.push(obj.code + ':' + obj.value)
				} else if (obj.type === 11) {
					checkBox.push(obj.code + ':' + obj.items.map(x => x.value).join(','))
				} else if (obj.type === 12) {
					checkone.push(obj.code + ':' + obj.items.value)
				} else if (obj.type === 20) {
					textfiled.push(obj.code + ':' + obj.items.value)
				}
				if (obj.type === 10) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(단일선택)',
						category_details: obj.category_details,
						value:
							obj.category_details.filter(x => x.detailcode === obj.value).length > 0
								? obj.category_details.filter(x => x.detailcode === obj.value)[0].detailname
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 11) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(다중선택)',
						category_details: obj.category_details,
						value:
							obj.items.filter(x => x.value !== '').length > 0
								? obj.items
										.filter(x => x.value !== '')
										.map(x => x.label)
										.join(',')
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.tag === 'location') {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '지역',
						category_details: obj.category_details,
						value:
							this.$store.state.searchsel_city1.value +
							'_' +
							this.$store.state.searchsel_city2.value +
							'_' +
							this.$store.state.searchsel_city3.value,
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 20) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						value: obj.items.value,
						qusType: '주관식',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 21) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						qusType: '파일업로드',
						imgFiles: this.imgFiles,
						reserveGroupCode: this.$route.params.subCode,
					})
				}
			})
			const data = {
				title: this.reservedaysData.title,
				inputBoxTitle: this.$store.state.reservedayInputBox.name,
				ismarketing: 1,
				ispersonal: 1,
				stat: 9,
				name: this.direct.nameTxtfield.value,
				phone: this.direct.phoneTxtfield.value.replace(/-/g, ''),
				custlike: this.direct.radios.radioSelected,
				checkbox: checkBox.join('/'),
				textfiled: textfiled.join('/'),
				checkone: checkone.join('/'),
				date: this.$moment(new Date()).add(9, 'hour'),
				counselorid: this.$store.state.counserlorLoginData.counselorid
					? this.$store.state.counserlorLoginData.counselorid
					: localStorage.getItem('counserlor').split(',')[1],
				rdate: this.$moment(new Date()).add(9, 'hour'),
				cdate: this.$moment(new Date()).add(9, 'hour'),
				recomand: this.direct.custComment,
				code: this.$route.params.code,
				seat: Number(this.$store.state.counserlorLoginData.seat),
				locationData:
					this.$store.state.reservedayInputBoxDirect.categories.map(x => x.type).indexOf(20) > -1
						? this.$store.state.searchsel_city1.value +
						  '_' +
						  this.$store.state.searchsel_city2.value +
						  '_' +
						  this.$store.state.searchsel_city3.value
						: '',
				userData: userDataInput,
				sex: sex,
				realname: realname,
				age: age,
				qualification: qualification,
				homeOwnership: homeOwnership,
				bankBook: bankBook,
				purpose: purpose,
				subscribe: subscribe,
				floor: floor,
				houseAcreage: houseAcreage,
				acreageUnit: acreageUnit,
				business: this.reservedaysData.business ? Number(this.reservedaysData.business.id) : null,
				marketing: this.$store.state.check5.value,
				receiveInformation: this.$store.state.check6.value,
				location: location,
				locationType: locationType,
			}
			if (ok === 0) {
				this.$store
					.dispatch('createWaiting', data)
					.then(() => {
						this.$store.state.loading = false
						this.cancelDirectwaitingDailog()
						alert('상담수기 등록이 완료되었습니다.')
					})
					.catch(() => {
						alert('상담수기 등록시 오류가 발생하였습니다. 관리자에게 문의하세요.')
						this.$store.state.loading = false
					})
			}
		},
		cancelDirectwaitingDailog() {
			this.direct_dialog = false
			this.direct = {
				custComment: '',
				radios: {
					radioSelected: '',
					items: [
						{ label: 'S', value: 'S' },
						{ label: 'A', value: 'A' },
						{ label: 'B', value: 'B' },
						{ label: 'C', value: 'C' },
						{ label: 'D', value: 'D' },
					],
					color: '#202840',
				},
				nameTxtfield: {
					value: '',
					outlined: true,
					label: '고객성명',
					placeholder: '고객성명',
				},
				phoneTxtfield: {
					value: '',
					outlined: true,
					label: '고객 휴대전화번호',
					placeholder: '고객 휴대전화번호',
				},
			}
		},
		directwaitingDailog() {
			this.$store.state.reservedayInputBoxDirect.categories.forEach(obj => {
				if (obj.type === 10) {
					obj.value = ''
					obj.etc = ''
					this.$store.state.nowRadioValue = []
				} else if (obj.type === 11) {
					obj.items.forEach(item => {
						item.value = ''
					})
				} else if (obj.type === 12 || obj.type === 20) {
					obj.items.value = ''
				}
			})
			this.componentKey += 1
			this.direct_dialog = true
		},
		completeSendMessage_5() {
			const data = {
				tplCode: this.reservedaysData.tplCode[5],
			}
			this.$store.dispatch('messages', data).then(res => {
				if (res.data.messages[0].message === undefined) {
					// 생성 / 수정시 알림톡 tpl_code가 없는 경우
					return
				} else {
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
				}
				let buttonDatas
				if (res.data.messages[0].button) {
					buttonDatas = JSON.parse(res.data.messages[0].button)
					buttonDatas.forEach(btn => {
						btn.linkPc = btn.linkPc.replace(/#{코드}/g, this.$route.params.code)
						btn.linkMo = btn.linkMo.replace(/#{코드}/g, this.$route.params.code)
					})
				}
				const sendData = {
					// 필수값

					code: this.$route.params.code,
					sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
					senderkey: process.env.VUE_APP_SENDERKEY,
					tpl_code: res.data.messages[0].tplCode,
					receiver_1: this.phoneTxtfield.value,
					subject_1: res.data.messages[0].tplCodeStr,
					message_1: res.data.messages[0].message,
					recvname_1: this.nameTxtfield.value,
					failover: 'Y',
					fsubject_1: res.data.messages[0].tplCodeStr,
					fmessage_1: res.data.messages[0].message,
					button_1: res.data.messages[0].button ? JSON.stringify(buttonDatas) : '[]',
					pay: this.reservedaysData.business?.id,
				}
				this.$store
					.dispatch('createSendMessage', sendData)
					.then(() => {
						this.nameTxtfield.value = ''
						this.phoneTxtfield.value = ''
					})
					.catch(err => {
						console.log({ err })
					})
			})
		},
		completeSendMessage_10() {
			if (this.reservedaysData.tplCode[11]) {
				const data = {
					tplCode: this.reservedaysData.tplCode[11],
				}
				this.$store.dispatch('messages', data).then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
						res.data.messages[0].message = res.data.messages[0].message.replace(
							/#{상담완료일시}/g,
							this.$moment().format('YYYY-MM-DD HH:mm'),
						)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button)
						buttonsData.forEach(element => {
							if (element.linkMo) {
								element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
								element.linkMo = element.linkMo.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
									element.linkMo = element.linkMo.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
								}
								element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							}
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
						senderkey: process.env.VUE_APP_SENDERKEY,
						receiver_1: this.phoneTxtfield.value,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						recvname_1: this.nameTxtfield.value,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store.dispatch('createSendMessage', sendData).then(() => {
						this.nameTxtfield.value = ''
						this.phoneTxtfield.value = ''
					})
				})
			}
		},
		// 상담호출 재호출 전송
		createSendMessage() {
			const data = {
				tplCode: this.reservedaysData.tplCode[6],
			}
			this.$store.dispatch('messages', data).then(res => {
				if (res.data.messages[0].message === undefined) {
					// 생성 / 수정시 알림톡 tpl_code가 없는 경우
					return
				} else {
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, this.waitingNumTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, this.waitingNumTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담석번호}/g, this.$store.state.counserlorLoginData.seat)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
				}
				if (res.data.messages[0].button) {
					const buttonsData = JSON.parse(res.data.messages[0].button)
					buttonsData.forEach(element => {
						if (element.linkMo) {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						}
					})
					res.data.messages[0].button = JSON.stringify(buttonsData)
				}
				const sendData = {
					// 필수값

					code: this.$route.params.code,
					sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
					senderkey: process.env.VUE_APP_SENDERKEY,
					tpl_code: res.data.messages[0].tplCode,
					receiver_1: this.phoneTxtfield.value,
					subject_1: res.data.messages[0].tplCodeStr,
					message_1: res.data.messages[0].message,
					recvname_1: this.nameTxtfield.value,
					failover: 'Y',
					fsubject_1: res.data.messages[0].tplCodeStr,
					fmessage_1: res.data.messages[0].message,
					button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
					pay: this.reservedaysData.business?.id,
				}
				this.$store
					.dispatch('createSendMessage', sendData)
					.then(() => {
						this.sendAlertModal.dialog = false
					})
					.catch(() => {
						alert('알림톡 전송시 오류가 발생 하였습니다. 다시시도해 주세요.')
						this.sendAlertModal.dialog = false
					})
			})
		},
		sendAlertTalk() {
			this.sendAlertModal.dialog = true
		},
		selfAuthentication() {
			localStorage.removeItem('counserlor')
			// this.$router.push({ name: 'counselorlogin' })
			this.$router.go(-1)
			this.infoDialog.dialog = false
		},
		waitingsSocket() {
			setInterval(() => {
				const data = {
					code: this.$route.params.code,
					seat: 0,
					stat: 0,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
					_limit: 10,
				}
				// this.$store.dispatch('waitings', data).then(res => {
				this.$store.dispatch('waitingsConnection', data).then(res => {
					const waitingsPeople = res.data.waitingsConnection.aggregate.count
					this.waitNum = waitingsPeople
				})
				// this.realTimeWatingList = res.data.waitings
				// })
			}, 3000)
		},
		userHistory() {
			this.alertModal3.dialog = true
			this.alertModal3.name = this.nameTxtfield.value
			this.alertModal3.phone = this.phoneTxtfield.value
			this.alertModal3.waitingnum = this.waitingNumTxtfield.value
			this.alertModal3.datatable.items = this.datatable.items
			this.alertModal3.datatable.headers = this.datatable.headers
			let header = [
				{ text: '상담 날짜', value: 'cdate', width: '200px' },
				{ text: '사업지 명', value: 'title', width: '200px' },
				{ text: '상담사 아이디', value: 'counselorid', width: '200px' },
				{ text: '고객 등급', value: 'custlike', width: '200px' },
				{ text: '코멘트', value: 'recomand', width: '200px' },
				{ text: '방문 예약 날짜', value: 'rdate', width: '200px' },
			]
			let items = []
			// 사업지 중복 참여 여부
			let dupBusiness = []
			// export 항목 중복여부 data
			let dup = {}
			// excel export 항목 설정
			let exportField = {
				상담일시: 'cdate1',
				사업지명: 'title',
				'상담사 아이디': 'counselorid',
				'고객 등급': 'custlike',
				코멘트: 'recomand',
				예약일시: 'rdate1',
			}
			this.alertModal3.datatable.items.forEach((e, i) => {
				let dupIndex = dupBusiness.indexOf(e.code)
				if (dupIndex === -1) {
					dupBusiness.push(e.code)
				}
				// if (e.fileUpload.length !== 0) {
				// 	header = [
				// 		{ text: '상담 날짜', value: 'cdate' },
				// 		{ text: '상담사 아이디', value: 'counselorid' },
				// 		{ text: '고객 등급', value: 'custlike' },
				// 		{ text: '코멘트', value: 'recomand' },
				// 		{ text: '방문 예약 날짜', value: 'rdate' },
				// 		{ text: '이미지 첨부', value: 'imgUpload', width: '200px', align: 'center' },
				// 	]
				// }
				// 예약 목록으로 해당 방문예약 호출
				let item = {}
				let data1 = {
					code: e.code,
				}
				let status1
				if (e.status === null || e.status === 1) {
					status1 = '방문 예약'
				} else if (e.status === 2) {
					status1 = '예약 취소'
				}
				item.status = e.status
				item.status1 = status1

				let ismarketing
				let ispersonal
				if (e.ismarketing === 1) {
					ismarketing = 'Y'
				} else if (e.ismarketing === 2) {
					ismarketing = 'N'
				}
				if (e.ispersonal === 1) {
					ispersonal = 'Y'
				} else if (e.ispersonal === 2) {
					ispersonal = 'N'
				}

				item.ismarketing1 = ismarketing
				item.ispersonal1 = ispersonal

				this.$store
					.dispatch('reservedays', data1)
					.then(res => {
						//방문예약의 inputbox 정보 저장
						e.categories = res.data.reservedays[0].input_box.categories
						e.categories.forEach(a => {
							// inputbox type이 약관이 경우

							if (a.type === 90) {
								let ismarketing
								let ispersonal
								if (e.ismarketing === 1) {
									ismarketing = 'Y'
								} else if (e.ismarketing === 2) {
									ismarketing = 'N'
								}
								if (e.ispersonal === 1) {
									ispersonal = 'Y'
								} else if (e.ispersonal === 2) {
									ispersonal = 'N'
								}

								item.ismarketing1 = ismarketing
								item.ispersonal1 = ispersonal
							} else if (a.type === 31 || a.type === 30) {
								// type 날짜일 경우 예약일시 적용
							} else {
								//  inputbox type이 약관,날짜 아닐 경우 header 저장
								if (a.type !== 21) {
									if (dupIndex === -1) {
										header.push({
											text: a.codename,
											value: a.code + i,
											width: '200',
										})
										/// export key, value 설정
										if (a.codename in exportField) {
											let dupKey = a.codename + '(' + dup[a.codename] + ')'
											exportField[dupKey] = a.code + i
											dup[a.codename] += 1
										} else {
											dup[a.codename] = 1
											exportField[a.codename] = a.code + i
										}

										if (a.type === 11) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													let checkItem = []
													type
														.split(':')[1]
														.split(',')
														.forEach(detailCode => {
															if (detailCode) {
																let valIndex = a.category_details.findIndex(x => x.detailcode === detailCode)
																let value
																if (a.category_details[valIndex] !== undefined) {
																	value = a.category_details[valIndex].detailname
																	checkItem.push(value)
																}
															}
														})
													item[type.split(':')[0] + i] = checkItem.toString()
												}
											})
										} else if (a.type === 10) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code && type.split(':')[1]) {
													let valIndex = a.category_details.findIndex(x => x.detailcode === type.split(':')[1])
													let value
													if (a.category_details[valIndex] !== undefined) {
														value = a.category_details[valIndex].detailname

														if (value === '기타') {
															let etc = e.etc.split('/')
															let etcIndex = etc.findIndex(e => e.indexOf(type.split(':')[1]) !== -1)

															item[type.split(':')[0] + i] = etc[etcIndex].split(':')[1]
														} else {
															item[type.split(':')[0] + i] = value
														}
													}
												}
											})
										} else if (a.type === 12) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + i] = type.split(':')[1]
												}
											})
										} else if (a.type === 20) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + i] = type.split(':')[1]
												}
											})
										}
									} else {
										if (a.type === 11) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													let checkItem = []
													type
														.split(':')[1]
														.split(',')
														.forEach(detailCode => {
															if (detailCode) {
																let valIndex = a.category_details.findIndex(x => x.detailcode === detailCode)
																let value
																if (a.category_details[valIndex] !== undefined) {
																	value = a.category_details[valIndex].detailname
																	checkItem.push(value)
																}
															}
														})
													item[type.split(':')[0] + dupIndex] = checkItem.toString()
												}
											})
										} else if (a.type === 10) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code && type.split(':')[1]) {
													let valIndex = a.category_details.findIndex(x => x.detailcode === type.split(':')[1])
													let value
													if (a.category_details[valIndex] !== undefined) {
														value = a.category_details[valIndex].detailname
														if (value === '기타') {
															let etc = e.etc.split('/')
															let etcIndex = etc.findIndex(e => e.indexOf(type.split(':')[1]) !== -1)

															item[type.split(':')[0] + dupIndex] = etc[etcIndex].split(':')[1]
														} else {
															item[type.split(':')[0] + dupIndex] = value
														}
													}
												}
											})
										} else if (a.type === 12) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + dupIndex] = type.split(':')[1]
												}
											})
										} else if (a.type === 20) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + dupIndex] = type.split(':')[1]
												}
											})
										}
									}
								}
								// else if (a.type === 21) {
								// 	let images = []
								// 	const url = this.$store.state.backServer
								// 	e.fileUpload.forEach(x => {
								// 		images.push(url + x.url)
								// 	})

								// 	item['imgUpload'] = images
								// }
							}
						})

						//사업지명,등록일시 삽입
						item.title = e.title
						item.cdate = e.cdate
						item.counselorid = e.counselorid
						item.custlike = e.custlike
						item.recomand = e.recomand
						item.rdate = e.rdate

						// item.item.updated_at = this.$moment(e.updated_at).format('YYYY-MM-DD HH:mm:ss')
						// if (e.rdate) {
						// 	item.rdate = this.$moment(e.rdate).format('YYYY-MM-DD HH:mm:ss')
						// }
						if (e.rdate) {
							item.rdate = this.$moment(e.rdate).format('YYYY-MM-DD HH:mm:ss')
							item.rdate1 = this.$moment(e.rdate)
								.subtract(18, 'hours')
								.format('YYYY-MM-DD HH:mm:ss')
						}
						item.cdate1 = this.$moment(e.cdate)
							.subtract(9, 'hours')
							.format('YYYY-MM-DD HH:mm:ss')
						items.push(item)
					})
					.catch(() => {})
				this.alertModal3.datatable.headers = header
				this.alertModal3.datatable.items = items
				this.alertModal3.json_fields = exportField
			})
		},

		userExport() {
			document.getElementById(this.alertModal3.phone).click()
		},
		callWaitingData() {
			this.$store.state.loading = true
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				this.$store.state.reservedayInputBox = res.data.reservedays[0].input_box
				const data = {
					id: localStorage.getItem('waitingId'),
					code: this.$route.params.code,
				}
				this.$store
					.dispatch('waitings', data)
					.then(res => {
						let sorted = res.data.waitings.sort((a, b) => {
							if (a.waitingnum > b.waitingnum) return 1
							if (a.waitingnum === b.waitingnum) return 0
							if (a.waitingnum < b.waitingnum) return -1
						})
						this.counseringData = sorted[0]
						this.nameTxtfield.value = sorted[0].name
						this.phoneTxtfield.value = sorted[0].phone
						this.waitingNumTxtfield.value = String(sorted[0].waitingnum)
						if (sorted[0].ispersonal === 1) {
							this.check1.value = true
						} else {
							this.check3.value = true
						}
						if (sorted[0].ismarketing === 1) {
							this.check2.value = true
						} else {
							this.check3.value = true
						}
						this.$store.state.reserveusersData = sorted[0]
						if (this.$store.state.reservedayInputBox.categories.length > 0) {
							this.$store.state.reservedayInputBox.categories.forEach(element => {
								if (element.type === 11) {
									sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
										if (type.split(':')[0] === element.code) {
											type
												.split(':')[1]
												.split(',')
												.forEach((detailCode, index) => {
													element.items[index].value = detailCode
												})
										}
									})
								} else if (element.type === 10) {
									let etcArr = [] // 기타 값 임시저장
									let foundIdx
									if (sorted[0].etc !== null) {
										sorted[0].etc.split('/').forEach(el => {
											etcArr.push(el.split(':'))
										})
									}

									sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
										if (type.split(':')[0] === element.code) {
											element.value = type.split(':')[1]
										}
									})

									element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
									element.nowRadioValue = ''
									// 기타 선택지 값 삽입
									foundIdx = etcArr.findIndex(x => x[0] === element.value)
									if (foundIdx !== -1) {
										element.etc = etcArr[foundIdx][1]
									}
								} else if (element.type === 12) {
									sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
										if (type.split(':')[0] === element.code) {
											element.items.value = type.split(':')[1]
										}
									})
								} else if (element.type === 20) {
									sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
										if (type.split(':')[0] === element.code) {
											element.items.value = type.split(':')[1]
										}
									})
								}
							})
						}
						this.trackingCodes(sorted[0].phone)
						this.waitingId = sorted[0].id
						const setData = this.$store.state.reservedayInputBox
						this.$store.commit('reservedayInputBox', {})
						setTimeout(() => {
							this.$store.state.loading = false
							this.$store.commit('reservedayInputBox', setData)
						}, 500)
					})
					.catch(err => {
						console.log({ err })
						this.$store.state.loading = false
						localStorage.removeItem('waitingId')
						alert('오류가 발생하였습니다. 관리자에게 문의하세요!')
					})
			})
		},
		counselors(secret, created_at) {
			const data = {
				secret: secret,
				created_at: created_at,
				updated_at: created_at,
			}
			this.$store
				.dispatch('counselorLoginCheck', data)
				.then(res => {
					this.infoDialog.name = res.data.counselor.name
					this.infoDialog.seat = res.data.counselor.seat
					this.$store.state.counserlorLoginData = res.data.counselor
					// localStorage 에 상담중이던 waitings data가 남아있는 경우 해당 데이터 불러옴
					if (
						localStorage.getItem('waitingId') !== null &&
						localStorage.getItem('counselingIdNow') === this.$store.state.counserlorLoginData.counselorid
					) {
						this.callWaitingData()
					}
				})
				.catch(() => {
					alert('권한이 없는 사용자 입니다. 다시 로그인해 주세요.')
					this.$router.push({ name: 'counselorlogin', params: { code: this.$route.params.code } })
				})
		},
		trackingCodes(phone) {
			this.$store.dispatch('waitings', { phone: phone }).then(resWaiting => {
				const waitings = resWaiting.data.waitings
				let historyItem = []
				historyItem = waitings.filter(item => {
					return item.stat !== 0
				})
				waitings.forEach(e => {
					e.rdate = this.$moment(e.rdate)
						.add(9, 'hours')
						.format('YYYY-MM-DD HH:mm')
				})
				this.datatable.items = historyItem
			})
			// this.datatable.items.splice(0, 1)
		},
		// 상담호출 메세지 전송
		callMessage(reserveuser) {
			const data = {
				tplCode: this.reservedaysData.tplCode[6],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, reserveuser.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, reserveuser.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, reserveuser.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(
							/#{상담석번호}/g,
							this.$store.state.counserlorLoginData.seat,
						)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button)
						buttonsData.forEach(element => {
							if (element.linkMo) {
								element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
								element.linkMo = element.linkMo.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
									element.linkMo = element.linkMo.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
								}
								element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							}
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
						senderkey: process.env.VUE_APP_SENDERKEY,
						receiver_1: reserveuser.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: reserveuser.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {
							// for (let index = 0; index < 5; index++) {
							this.findTargetPreCall(reserveuser.waitingnum)
							// }
							// 대기알림 삭제 - 21. 10.24 - 이규화
							// this.findTargetStandby(reserveuser.waitingnum)
						})
						.catch(() => {})
				})
				.catch(() => {})
		},
		// 대기 알림 보낼 사람 찾기
		findTargetStandby(nowNumber) {
			const data = {
				code: this.$route.params.code,
				stat: 0,
			}
			this.$store
				.dispatch('waitings', data)
				.then(res => {
					const add5numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 5
					})
					const add10numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 10
					})
					const add15numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 15
					})
					const add20numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 20
					})
					const add25numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 25
					})
					// 대기번호 현재번호 +25 까지 대기자알림 보냄
					if (res.data.waitings.length > 5 && add5numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
					} else if (res.data.waitings.length > 10 && add10numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
					} else if (res.data.waitings.length > 15 && add15numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
						this.standbyMessage(res.data.waitings[add15numberIndex], 14)
					} else if (res.data.waitings.length > 20 && add20numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
						this.standbyMessage(res.data.waitings[add15numberIndex], 14)
						this.standbyMessage(res.data.waitings[add20numberIndex], 19)
					} else if (res.data.waitings.length > 25 && add25numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
						this.standbyMessage(res.data.waitings[add15numberIndex], 14)
						this.standbyMessage(res.data.waitings[add20numberIndex], 19)
						this.standbyMessage(res.data.waitings[add25numberIndex], 24)
					}
				})
				.catch(() => {})
		},
		// 대기 알림 전송
		standbyMessage(targetdata, frontNum) {
			const data = {
				tplCode: this.reservedaysData.tplCode[4],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, targetdata.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기자수}/g, frontNum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{내앞대기자수}/g, frontNum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button)
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
						senderkey: process.env.VUE_APP_SENDERKEY,
						tpl_code: res.data.messages[0].tplCode,
						receiver_1: targetdata.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: targetdata.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		// 내앞대기자 알림 보낼 사람 찾기
		async findTargetPreCall(waitingnum) {
			const data = {
				code: this.$route.params.code,
				waitingnum: waitingnum + 1,
				stat: 0,
			}
			await this.$store.dispatch('waitings', data).then(async resWa => {
				if (resWa.data.waitings[0]) {
					// const data = {
					//
					// 	code: this.$route.params.code,
					// 	tpl_code: this.reservedaysData.tplCode[4],
					// 	receiver_1: resWa.data.waitings[0].phone,
					// 	created_at_gte: this.$moment().subtract('hours', 1)._d,
					// }
					// await this.$store.dispatch('sendMessages', data).then(async resMs => {
					// if (resMs.data.sendMessages.length === 0) {
					const data = {
						tplCode: this.reservedaysData.tplCode[4],
					}
					await this.$store
						.dispatch('messages', data)
						.then(async res => {
							const targetdata = resWa.data.waitings[0]
							let bookday
							bookday = this.$moment(targetdata.cdate)
								.subtract(9, 'hours')
								.format('YYYY-MM-DD HH:mm')
							// setTimeout(() => {
							let messageData = JSON.parse(JSON.stringify(res.data.messages[0]))
							messageData.message = messageData.message.replace(/#{사업지명}/g, this.reservedaysData.title)
							messageData.message = messageData.message.replace(/#{고객명}/g, targetdata.name)
							messageData.message = messageData.message.replace(/#{대기번호1}/g, targetdata.waitingnum)
							messageData.message = messageData.message.replace(/#{대기번호2}/g, targetdata.waitingnum)
							messageData.message = messageData.message.replace(/#{상담신청일시}/g, bookday)
							messageData.message = messageData.message.replace(/#{대기자수}/g, 1)
							messageData.message = messageData.message.replace(/#{내앞대기자수}/g, 1)
							messageData.message = messageData.message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
							if (res.data.messages[0].button) {
								const buttonsData = JSON.parse(res.data.messages[0].button)
								buttonsData.forEach(element => {
									element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
									element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
									element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
									element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
									element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
									element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
									element.linkMo = element.linkMo.replace(
										/#{분양정보pdf}/g,
										this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{분양정보pdf}/g,
										this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
									)
									if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
										element.linkMo = element.linkMo.replace(
											/#{청약안내pdf}/g,
											this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
										)
										element.linkPc = element.linkPc.replace(
											/#{청약안내pdf}/g,
											this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
										)
									}
									element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
									element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
									element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
									element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								})
								res.data.messages[0].button = JSON.stringify(buttonsData)
							}
							const sendData = {
								// 필수값

								code: this.$route.params.code,
								sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
								senderkey: process.env.VUE_APP_SENDERKEY,
								tpl_code: res.data.messages[0].tplCode,
								receiver_1: targetdata.phone,
								subject_1: res.data.messages[0].tplCodeStr,
								message_1: messageData.message,
								// 여기까지 필수값
								recvname_1: targetdata.name,
								failover: 'Y',
								fsubject_1: res.data.messages[0].tplCodeStr,
								fmessage_1: messageData.message,
								button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
								pay: this.reservedaysData.business?.id,
							}
							this.$store
								.dispatch('createSendMessage', sendData)
								.then(() => {})
								.catch(() => {})
							// }, 500 * index)
						})
						.catch(err => {
							console.log({ err })
						})
					// }
					// })
				}
			})
		},
		// 내앞대기자 알림톡 전송
		async preCallMessage(targetdata) {
			const data = {
				tplCode: this.reservedaysData.tplCode[4],
			}
			await this.$store
				.dispatch('messages', data)
				.then(res => {
					let bookday
					if (targetdata === undefined) {
						return
					} else {
						bookday = this.$moment(targetdata.cdate)
							.subtract(9, 'hours')
							.format('YYYY-MM-DD HH:mm')
					}
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, targetdata.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담신청일시}/g, bookday)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button)
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
						senderkey: process.env.VUE_APP_SENDERKEY,
						receiver_1: targetdata.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: targetdata.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		// 미처리 메세지 전송
		unattendedMessage(reserveuser) {
			const data = {
				tplCode: this.reservedaysData.tplCode[7],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let reserveDayurl = `${location.protocol}//${location.hostname}/reserve_day/${this.$route.params.code}`
					const bookday = this.$moment(reserveuser.created_at).format('YYYY년MM월DD일 HH:mm')
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, reserveuser.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담신청일시}/g, bookday)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{예약URL}/g, reserveDayurl)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대표번호}/g, this.reservedaysData.callerNumber)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button)
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, reserveuser.phone)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, reserveuser.phone)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						sender: this.reservedaysData.callerNumber ? this.reservedaysData.callerNumber : process.env.VUE_APP_SENDER,
						senderkey: process.env.VUE_APP_SENDERKEY,
						tpl_code: res.data.messages[0].tplCode,
						receiver_1: reserveuser.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: reserveuser.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		complete() {
			let ok = 0
			if (this.radios.radioSelected === '') {
				this.alertModal2.dialog = true
				this.alertModal2.text = '고객 성향을 선택해 주세요.'
				ok += 1
			}
			// if (this.check1.value && !this.check2.value) {
			// 	this.alertModal2.dialog = true
			// 	this.alertModal2.text = '분양정보 제공 및 마케팅 활용 동의를 체크해 주세요.'
			// 	ok += 1
			// }
			// if (!this.check1.value && this.check2.value) {
			// 	this.alertModal2.dialog = true
			// 	this.alertModal2.text = '개인정보 수집동의를 체크해 주세요.'
			// 	ok += 1
			// }
			const checkBox = []
			const checkone = []
			const textfiled = []
			let userDataInput = []
			let sex = null
			let realname = null
			let age = null
			let qualification = null
			let homeOwnership = null
			let bankBook = null
			let purpose = null
			let subscribe = null
			let floor = null
			let houseAcreage = null
			let acreageUnit = null
			let location = null
			let locationType = null
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.tag === 'name') {
					realname = obj.items.value
				} else if (obj.tag === 'age') {
					if (obj.category_details.length > 0 && obj.value)
						age = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'sex') {
					if (obj.category_details.length > 0 && obj.value)
						sex = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'qualification') {
					if (obj.category_details.length > 0 && obj.value)
						qualification = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'homeOwnership') {
					if (obj.category_details.length > 0 && obj.value)
						homeOwnership = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'bankBook') {
					if (obj.category_details.length > 0 && obj.value)
						bankBook = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'purpose') {
					if (obj.category_details.length > 0 && obj.value)
						purpose = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'subscribe') {
					if (obj.category_details.length > 0 && obj.value)
						subscribe = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'floor') {
					if (obj.category_details.length > 0 && obj.value)
						floor = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'houseAcreage') {
					if (obj.category_details.length > 0 && obj.value) {
						houseAcreage = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						acreageUnit = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				} else if (obj.tag === 'locationType') {
					if (obj.category_details.length > 0 && obj.value) {
						location = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						locationType = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				}
				if (obj.type === 10) {
					checkone.push(obj.code + ':' + obj.value)
				} else if (obj.type === 11) {
					checkBox.push(obj.code + ':' + obj.items.map(x => x.value).join(','))
				} else if (obj.type === 12) {
					checkone.push(obj.code + ':' + obj.items.value)
				} else if (obj.type === 20) {
					textfiled.push(obj.code + ':' + obj.items.value)
				}
				if (obj.type === 10) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(단일선택)',
						category_details: obj.category_details,
						value:
							obj.category_details.filter(x => x.detailcode === obj.value).length > 0
								? obj.category_details.filter(x => x.detailcode === obj.value)[0].detailname
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 11) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(다중선택)',
						category_details: obj.category_details,
						value:
							obj.items.filter(x => x.value !== '').length > 0
								? obj.items
										.filter(x => x.value !== '')
										.map(x => x.label)
										.join(',')
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.tag === 'location') {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '지역',
						category_details: obj.category_details,
						value:
							this.$store.state.searchsel_city1.value +
							'_' +
							this.$store.state.searchsel_city2.value +
							'_' +
							this.$store.state.searchsel_city3.value,
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 20) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						value: obj.items.value,
						qusType: '주관식',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 21) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						qusType: '파일업로드',
						imgFiles: this.imgFiles,
						reserveGroupCode: this.$route.params.subCode,
					})
				}
			})
			let tags = ''
			if (this.selectedTag.length > 0) {
				let items = []
				this.selectedTag.forEach(e => {
					items.push(this.reservedaysData.commentTag[e])
				})
				tags = items.join(', ')
			}
			const data = {
				ismarketing: 1,
				ispersonal: 1,
				stat: 9,
				custlike: this.radios.radioSelected,
				checkbox: checkBox.join('/'),
				textfiled: textfiled.join('/'),
				checkone: checkone.join('/'),
				date: this.$moment(new Date()).add(9, 'hour'),
				// counselorid: this.$store.state.counserlorLoginData.counselorid
				// 	? this.$store.state.counserlorLoginData.counselorid
				// 	: localStorage.getItem('counserlor').split(',')[1],
				// id: localStorage.getItem('waitingId'),
				id: this.waitingId,
				recomand: this.custComment,

				code: this.$route.params.code,
				// seat: Number(this.$store.state.counserlorLoginData.seat),
				commentTag: tags,
				locationData:
					this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
						? this.$store.state.searchsel_city1.value +
						  '_' +
						  this.$store.state.searchsel_city2.value +
						  '_' +
						  this.$store.state.searchsel_city3.value
						: '',
				userData: userDataInput,
				sex: sex,
				realname: realname,
				age: age,
				qualification: qualification,
				homeOwnership: homeOwnership,
				bankBook: bankBook,
				purpose: purpose,
				subscribe: subscribe,
				floor: floor,
				houseAcreage: houseAcreage,
				acreageUnit: acreageUnit,
				location: location,
				locationType: locationType,
			}
			if (ok === 0) {
				this.$store
					.dispatch('updateWaiting', data)
					.then(() => {
						if (this.reservedaysData.tplCode[11]) {
							this.completeSendMessage_10()
							// this.completeSendMessage_5()
						} else {
							this.nameTxtfield.value = ''
							this.phoneTxtfield.value = ''
						}
						// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
						// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
						// this.$socket.emit('reservation', { code: this.$route.params.code })
						this.counseringData = {}
						this.radios.radioSelected = ''
						this.check1.value = false
						this.check2.value = false
						this.check3.value = false
						this.waitingNumTxtfield.value = ''
						this.$store.state.loading = false
						this.datatable.items = []
						this.selectedTag = []
						this.reservedays()
						this.custComment = '' // 코멘트 초기화
						localStorage.removeItem('waitingId') // localStorage waitingId 초기화
						localStorage.removeItem('counselingIdNow') // localStorage counselingIdNow 초기화
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			}
		},
		setStat2() {
			const data = {
				stat: 2,
				// id: localStorage.getItem('waitingId'),
				id: this.waitingId,

				code: this.$route.params.code,
				// seat: Number(this.$store.state.counserlorLoginData.seat),
				// counselorid: this.$store.state.counserlorLoginData.counselorid
				// 	? this.$store.state.counserlorLoginData.counselorid
				// 	: localStorage.getItem('counserlor').split(',')[1],
				custlike: '미처리',
			}
			this.$store
				.dispatch('updateWaiting', data)
				.then(res => {
					// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
					// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
					// this.$socket.emit('reservation', { code: this.$route.params.code })
					this.unattendedMessage(res.data.updateWaiting.waiting)
					this.counseringData = {}
					this.radios.radioSelected = ''
					this.check1.value = false
					this.check2.value = false
					this.check3.value = false

					this.waitingNumTxtfield.value = ''
					this.custComment = '' // 코멘트 초기화
					this.$store.state.loading = false
					this.datatable.items = []
					this.selectedTag = []
					this.reservedays()
					this.nameTxtfield.value = ''
					this.phoneTxtfield.value = ''
					localStorage.removeItem('waitingId') // localStorage waitingId 초기화
					localStorage.removeItem('counselingIdNow') // localStorage counselingIdNow 초기화
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reservedays', data)
				.then(res => {
					this.placeTitle = res.data.reservedays[0].title
					this.reservedaysData = res.data.reservedays[0]
					this.logoutbtn.color = this.reservedaysData.business.color
					// 설문 데이터 value 삽입
					this.$store.state.reserveusersData.fileUpload = {}
					res.data.reservedays[0].input_box.categories.forEach(element => {
						if (element.type === 10) {
							element.value = ''
							element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
							element.nowRadioValue = ''
							element.etc = ''
						} else if (element.type === 11) {
							element.category_details.forEach(detail => {
								if (!element.items) {
									element.items = []
								}
								element.items.push({
									value: '',
									label: detail.detailname,
									color: '',
									class: '',
									errorMessage: '',
									hideDetail: true,
									detailcode: detail.detailcode,
								})
							})
						} else if (element.type === 12) {
							element.items = { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }
						} else if (element.type === 20) {
							element.items = { value: '', maxlength: '255', outlined: true, autofocus: false, hideDetail: false, errorMessage: '' }
						}
					})
					if (res.data.reservedays[0].business) {
						if (res.data.reservedays[0].business.term) this.$store.state.termId = res.data.reservedays[0].business.term.id
						let li = []
						if (res.data.reservedays[0].business.useTerm) {
							li.push(res.data.reservedays[0].business.useTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.privacyTerm_reserveday) {
							li.push(res.data.reservedays[0].business.privacyTerm_reserveday)
						} else li.push(null)
						if (res.data.reservedays[0].business.uniqueTerm) {
							li.push(res.data.reservedays[0].business.uniqueTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.marketingTerm_reserveday) {
							li.push(res.data.reservedays[0].business.marketingTerm_reserveday)
						} else li.push(null)
						if (res.data.reservedays[0].business.adTerm) {
							li.push(res.data.reservedays[0].business.adTerm)
						} else li.push(null)
						this.$store.state.termIdList = li
					}
					res.data.reservedays[0].input_box.categories = res.data.reservedays[0].input_box.categories.filter(x => x.type < 29)
					this.$store.commit('reservedayInputBox', res.data.reservedays[0].input_box)
					this.$store.commit('reservedayInputBoxDirect', res.data.reservedays[0].input_box)
				})
				.catch(() => {})
		},
		waitings() {
			const data = {
				code: this.$route.params.code,
				seat: 0,
				stat: 0,
				csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment(new Date())
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				_limit: 10,
			}
			// this.$store
			// 	.dispatch('waitings', data)
			// 	.then(res => {
			// 		this.realTimeWatingList = res.data.waitings
			this.$store.dispatch('waitingsConnection', data).then(res => {
				const waitingsPeople = res.data.waitingsConnection.aggregate.count
				this.waitNum = waitingsPeople
			})
		},

		checkAgree() {
			if (this.check3.value) {
				this.check3.value = false
			}
		},
		disagree() {
			if (this.check3.value) {
				this.check1.value = false
				this.check2.value = false
			}
		},
		deleteAccount() {
			this.$router.push({ name: 'counselorlogin' })
			this.alertModal.dialog = false
		},

		clickDeleteBtn() {
			this.alertModal.dialog = true
		},
		logout() {
			localStorage.removeItem('counserlor')
			this.alertModal.dialog = true
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		send() {
			if (this.waitNum > 0) {
				this.$store.state.loading = true
				const data = {
					code: this.$route.params.code,
					seat: 0,
					stat: 0,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				}
				this.$store.dispatch('waitings', data).then(res => {
					let sorted = res.data.waitings.sort((a, b) => {
						if (a.waitingnum > b.waitingnum) return 1
						if (a.waitingnum === b.waitingnum) return 0
						if (a.waitingnum < b.waitingnum) return -1
					})
					if (sorted[0].locationData) {
						this.$store.state.searchsel_city1.value = sorted[0].locationData.split('_')[0]
						this.$store.state.searchsel_city2.items = location1[sorted[0].locationData.split('_')[0]].sort()
						if (this.$store.state.searchsel_city2.items.indexOf(sorted[0].locationData.split('_')[1]) > -1) {
							this.$store.state.searchsel_city2.value = sorted[0].locationData.split('_')[1]
							this.$store.state.searchsel_city3.items = location2[sorted[0].locationData.split('_')[0]][
								sorted[0].locationData.split('_')[1]
							].sort()
							if (this.$store.state.searchsel_city3.items.indexOf(sorted[0].locationData.split('_')[2]) > -1) {
								this.$store.state.searchsel_city3.value = sorted[0].locationData.split('_')[2]
							}
						}
					}
					this.waitingId = sorted[0].id
					const data = {
						id: this.waitingId,

						code: this.$route.params.code,
						stat: 1,
						seat: Number(this.$store.state.counserlorLoginData.seat),
						counselorid: this.$store.state.counserlorLoginData.counselorid
							? this.$store.state.counserlorLoginData.counselorid
							: localStorage.getItem('counserlor').split(',')[1],
					}
					this.$store
						.dispatch('updateWaiting', data)
						.then(updateRes => {
							setTimeout(() => {
								const data = {
									id: updateRes.data.updateWaiting.waiting.id,
								}
								this.$store.dispatch('waiting', data).then(oneRes => {
									if (oneRes.data.waiting.counselorid === this.$store.state.counserlorLoginData.counselorid) {
										// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
										// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
										// this.$socket.emit('reservation', { code: this.$route.params.code })
										localStorage.setItem('waitingId', updateRes.data.updateWaiting.waiting.id)
										localStorage.setItem('counselingIdNow', this.$store.state.counserlorLoginData.counselorid)
										this.waitings()
										this.counseringData = sorted[0]
										this.nameTxtfield.value = sorted[0].name
										this.phoneTxtfield.value = sorted[0].phone
										this.waitingNumTxtfield.value = String(sorted[0].waitingnum)
										if (sorted[0].ispersonal === 1) {
											this.check1.value = true
										} else {
											this.check3.value = true
										}
										if (sorted[0].ismarketing === 1) {
											this.check2.value = true
										} else {
											this.check3.value = true
										}
										this.callMessage(sorted[0]) // 상담호출 메세지 전송
										this.$store.state.reserveusersData = sorted[0]
										this.$store.state.reservedayInputBox.categories.forEach(element => {
											if (element.type === 11) {
												sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
													if (type.split(':')[0] === element.code) {
														type
															.split(':')[1]
															.split(',')
															.forEach((detailCode, index) => {
																element.items[index].value = detailCode
															})
													}
												})
											} else if (element.type === 10) {
												let etcArr = [] // 기타 값 임시저장
												let foundIdx
												// 기타 값 없을때 분기 필요
												if (sorted[0].etc !== null) {
													sorted[0].etc.split('/').forEach(el => {
														etcArr.push(el.split(':'))
													})
												}

												sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
													if (type.split(':')[0] === element.code) {
														element.value = type.split(':')[1]
													}
												})

												// 기타 선택지 값 삽입
												foundIdx = etcArr.findIndex(x => x[0] === element.value)
												if (foundIdx !== -1) {
													element.etc = etcArr[foundIdx][1]
												}
											} else if (element.type === 12) {
												sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
													if (type.split(':')[0] === element.code) {
														element.items.value = type.split(':')[1]
													}
												})
											} else if (element.type === 20) {
												sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
													if (type.split(':')[0] === element.code) {
														element.items.value = type.split(':')[1]
													}
												})
											}
										})
										this.trackingCodes(sorted[0].phone)
										const setData = this.$store.state.reservedayInputBox
										this.$store.commit('reservedayInputBox', {})
										setTimeout(() => {
											this.$store.state.loading = false
											this.$store.commit('reservedayInputBox', setData)
										}, 500)
									} else {
										alert('이미 호출된 회원입니다.')
										this.$store.state.loading = false
									}
								})
							}, 800)
						})
						.catch(err => {
							console.log({ err })
							this.$store.state.loading = false
						})
					// })
					// .catch(() => {
					// 	this.$store.state.loading = false
					// 	alert('오류가 발생하였습니다. 관리자에게 문의하세요.')
				})
			}
		},
	},
}
</script>

<style lang="scss">
.waitingDialog {
	background-color: white !important;
}
.v-data-table-header-mobile {
	th {
		width: 100% !important;
	}
}
.forHistoryBtn {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.counselorContents {
	margin-top: 100px !important;
	min-height: 89vh;
	height: auto;
}
.tracking-table {
	padding: 0px 40px 20px 40px;
}
.view-port_counselor {
	.viewport-item-counselor {
		padding-top: 16px !important;
	}
	display: flex;
	flex-flow: wrap;
	.viewport-item {
		padding: 10px 5px 5px 5px !important;
		justify-content: start !important;
		align-content: start !important;
		flex-grow: 0;
	}
	.surveyName {
		font-weight: bold !important;
	}
}
.fab-counselor-icon {
	bottom: 40px !important;
}
.fab-counselor-icon-2 {
	bottom: 65px !important;
	right: 50px !important;
}
.couselorHead {
	height: 80px !important;
	padding: 12px 0px 0px 20px;
	background-color: white !important;
	border-bottom: 1px solid #d4d4d4;
	border-color: #d4d4d4 !important ;
	background: no-repeat left/contain url('../../assets/images/conselor_headerx2.png');
}
.bigHeader {
	font-size: 34px;
	font-weight: bold;
	color: white;
}
.couselorMain {
	max-width: 1060px;
	// width: 100vw;
}
.divider {
	border: 1px #cbd6da solid;
}
.rightSort {
	font-size: 14px;
	font-weight: bold;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.customerInfo {
	width: 200px !important;
	margin-top: 8px !important;
}
.counselorid {
	font-size: 16px;
	font-weight: bold;
	color: #0168b2;
}
.customerList {
	font-size: 16px;
	font-weight: bold;
	color: #6b567b;
}
.waitNum {
	span {
		font-size: 18px !important;
	}
	font-size: 18px;
	font-weight: bold;
	color: #4d4d4d;
}
.layout {
	min-width: 0px !important;
}
.counselorBack {
	background-color: white;
}
.pre-viewport_counselor {
	padding: 0px 15px 10px 15px;
	margin-top: 8px !important;
	background-color: white;

	.viewport-item {
		.width300 {
			width: 350px;
		}
		padding: 10px 0px;
		// border-bottom: 0.5px dashed #e0e0e0;
	}
}
.customerInfo-phone {
	.v-input__control {
		.v-input__slot {
			width: 200px !important;
			.v-text-field__slot {
				label {
					top: 9px !important;
					&.v-label--active {
						top: 16px !important;
					}
				}
			}
		}
	}
}
.vertical_divider {
	border-width: 0 2px 0 0 !important;
}
.counselor_content_wrap {
	max-height: calc(100vh - 100px);
	overflow-y: auto;
}
</style>
